<template lang="pug">
.algolia-results
  .container.pb-5
    .row.wide-gutters
      .col-12.col-lg-3.order-2
        .sidebar-wrap(
          style="position: sticky; top: 0px;"
        )
          .custom-control.custom-checkbox.mb-3(
            v-if="isAdmin"
          )
            input.custom-control-input(
              type="checkbox" 
              v-model="featuredOnly"
              id="featuredResultsToggle"
            )
            label.custom-control-label(
              for="featuredResultsToggle"
            ) Featured Results Only
          
          .mb-3
            h3.meta-label Filter by Date

            .d-flex.flex-column.date-choices

              button.btn.btn-outline-primary.text-left(
                v-for="preset in filterByDateButtons"
                :class="{active: preset.value == filterByDate}"
                @click="filterByDate = filterByDate == preset.value ? '' : preset.value"
              ) 
                span {{ preset.label }}
                span.mdi.mdi-close(
                  v-if="preset.value == filterByDate"
                )
              
              date-picker(
                range
                format="MM/DD/YYYY"
                range-separator=" - "
                placeholder="Choose Date Range"
                v-model="dateRange"
                :disabled-date="disableFutureDates"
                :default-value="defaultDate"
              )

          .mb-3(
            v-if="!query || !queries.suggestions.hits.length"
          )
            
            h3.meta-label.text-white Popular Searches
            ul.popular-searches
              li(
                v-for="term in popular"
                :key="`popular-${term}`"
              )
                button(
                  @click.prevent="setQuery(term)"
                  :title="term"
                )
                  span.mdi.mdi-magnify
                  span {{ term }}
          .mb-2(
            v-else
          )
            h3.meta-label.text-white Related Searches
            ul.popular-searches
              li(
                v-for="hit in queries.suggestions.hits"
                :key="`suggestion-${hit.query}`"
              )
                button(
                  @click="setQuery(hit.query)"
                  :title="hit.query"
                )
                  span.mdi.mdi-magnify
                  span {{ hit.query }}


      .col-12.col-lg-8.offset-lg-1.order-lg-3
        
        .no-query(
          v-if="!query"
        )
          // what should go here?
          p Starting typing your search in the field above.

        ul.mb-3.search-filters(
          v-if="availableFilters.length && query"
        )
          li(
            v-if="activeFilters.length"
          )
            button(
              type="button"
              @click.prevent="toggleFilter(null)"
            )
              span.mdi.mdi-chevron-left
              span All
          li(
            v-for="(filter,i) in availableFilters"
          )
            button(
              type="button"
              @click.prevent="toggleFilter(filter)"
              :class='{"active": filter.active}'
            )
              span {{ filter.label }}

        .asa-sortby.d-flex.justify-content-end.mb-3(
          v-if="activeQuery && activeQuery.hits && activeQuery.hits.length > 0"
        )
          div Sort by:
          div.asa-sortby__options.btn-group.btn-group-toggle
            li.asa-sortby__option
              a.asa-sortby__link(
                :class="{active: sortBy != 'date'}"
                href="#"
                @click.prevent="sortBy = 'relevance'"
              ) Relevance
            li.asa-sortby__option
              a.asa-sortby__link(
                :class="{active: sortBy == 'date'}"
                href="#"
                @click.prevent="sortBy = 'date'"
              ) Date

        search-feed(
          v-if="activeQuery"
          :queryID="activeQuery.queryID"
          :hits="activeQuery.hits"
          :query="query"
          :index="activeQuery.$q.request.indexName"
          :aa="aa"
          :algoliaQuery="activeQuery.$q"
          :sortBy="sortBy"
          name="allSites"
          context="Header"
          @clear-cache="clearCache"
        )

        .no-results(
          v-if="query && activeQuery && !activeQuery.hits.length"
        )
          p We couldn't find any results for that search.

</template>

<script>
const $ = jQuery;
export default {
  
  name: "algolia-search",

  components: {
    'search-feed' : () => import('./search-feed'),
    'date-picker' : () => import('vue2-datepicker')
  },

  props: {
    input: {
      type: HTMLElement,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },

  data(){
    const response = null;
    const hits = [];
    const total = 0;
    const $q = null;
    const isSearching = false;
    const filters = this.config.filters.map( filter => {
      filter.active = false;
      return filter;
    });
    return {
      query: '',
      client: null,
      aa: null,
      empty: true,
      dateRange: '',
      filters,
      featuredOnly: false,
      activeQuery: false,
      sortBy: 'relevance',
      defaultDate: new Date((new Date().getTime() - (1000 * 60 * 60 * 24 * 28))),
      filterByDateButtons: [{
        label: 'Past Month',
        value: '-1m'
      },{
        label: 'Past Quarter',
        value: '-1q'
      },{
        label: 'Past Year',
        value: '-1y'
      }],
      filterByDate: '',
      queries: {
        allSites: {
          hits, response, total, $q, isSearching
        },
        allSitesByDate: {
          hits, response, total, $q, isSearching
        },
        suggestions: {
          hits, response, total, $q, isSearching
        },
        popular: {
          hits, response, total, $q, isSearching
        }
      }
    }
  },

  computed: {
    isAdmin(){
      return theme_config.super_admin
    },
    hasResults(){
      return Object.values(this.queries).filter( q => q && q.hits && q.hits.length ).length > 0;
    },
    popular(){
      const total = 6;
      // check for hardcoded
      const queries = (this.config.suggestions||'').split(',').map(s => s.replace(/^\s+|\s+$/, '')).filter( s => !!s );
      if( this.queries.popular.hits ){
        for( let i=0; i<this.queries.popular.hits.length && queries.length < total; i++){
          queries.push( this.queries.popular.hits[i].query );
        }
      }
      return queries; 
    },
    activeFilters(){
      return this.filters.filter( f => f.active );
    },
    availableFilters(){
      return this.filters.filter( f => {
        if( f.active ){
          return true;
        }
        if( this.queries.allSites.response ){
          
          if( f.filter_type == 'attribute'){
            // if( !this.queries.allSites.response.facets[f.condition.attribute_name][f.condition.attribute_value] ) {
            //   // return false;
            // }
          }
          else {

          }
        }
        return true;
      });
    }
  },
  created(){
    Promise.all([
      import('../helpers/search'),
      import('algoliasearch'),
      import('search-insights')
    ]).then(([search, AlgoliaSearch, aa]) => {

      this.client = new AlgoliaSearch(
        this.config.application_id,
        this.config.search_api_key
      );

      const client = this.searchWrapper = new search.SearchWrapper( this.client );
      const insightParameters = {
        appId: this.config.application_id,
        apiKey: this.config.search_api_key
      };
      if( this.config.user_token ){
        insightParameters.userToken = this.config.user_token;
      }
      window.aa = this.aa = aa;
      
      aa('init', insightParameters);

      this.queries.popular.$q = search.queries.suggestions({
        client,
        request: {
          indexName: this.config.suggestionIndexName
        }
      })
      this.queries.popular.$q.target = this.queries.popular;

      this.queries.suggestions.$q = search.queries.suggestions({
        client,
        request: {
          indexName: this.config.suggestionIndexName
        }
      })
      this.queries.suggestions.$q.target = this.queries.suggestions;

      this.queries.allSites.$q = search.queries.allSites({
        client
      });
      this.queries.allSites.$q.target = this.queries.allSites;

      this.queries.allSitesByDate.$q = search.queries.allSitesByDate({
        client
      });
      this.queries.allSitesByDate.$q.target = this.queries.allSitesByDate;
      
      this.activeQuery = this.queries.allSites;

      // initialize the popular queries
      this.queries.popular.$q.search('');
    });
  },

  mounted(){
    $(this.input).attr({
      autocomplete: 'off',
      autocorrect: 'off',
      autocapitalize: 'off'
    });
    $(this.input)
      .on('input.algolia-search', e => this.onInput(e) )
      .on('focus.algolia-search', e => this.onFocus(e) );

    $(this.input).closest('form')
      .on('submit', e => e.preventDefault() )
      .find( 'button[type="submit"]' ).hide();

    this.$clear = $(this.input).closest('form').find('button[data-action="clear"]');
    this.$clear.on('click', () => $(this.input).val('').trigger('input').trigger('empty') );
  },

  beforeDestroy(){
    $(this.input).off('.algolia-search');
  },

  watch: {
    empty(v){
      // this.$clear.toggleClass('shown', !v);
      $(this.input).trigger( v ? 'empty' : 'notempty' );
    },
    featuredOnly(v){
      this.search();
    },
    sortBy(v){
      this.activeQuery = v == 'date' ? this.queries.allSitesByDate : this.queries.allSites;
      this.search();
    },

    dateRange(v){
      if( v ){
        this.filterByDate = 'range';
      }
      else if( this.filterByDate == 'custom') {
        this.filterByDate = '';
      }
      clearTimeout( this.searchTimeout );
      this.searchTimeout = setTimeout( () => this.search(), 120 );
    },

    filterByDate(v, old){
      if( v !== 'range' && old == 'range' ){
        this.dateRange = '';
      }
      clearTimeout( this.searchTimeout );
      this.searchTimeout = setTimeout( () => this.search(), 120 );
    }
  },

  methods: {
    disableFutureDates(d){
      return d > (new Date());
    },

    startOfQuarter(){
      let today = new Date();
      let d = new Date();
      d.setTime( today.getTime() - 1000 * 60 * 60 * 24 * 30 * 3);
      return d;
    },
    startOfYear(){
      let today = new Date();
      let d = new Date();
      d.setTime( today.getTime() - 1000 * 60 * 60 * 24 * 365);
      return d;
    },
    startOfMonth(){
      let today = new Date();
      let d = new Date();
      d.setTime( today.getTime() - 1000 * 60 * 60 * 24 * 30 );
      return d;
    },
    unixTimestamp(v){
      return v.getTime() / 1000;
    },

    setQuery( term ){
      this.input.value = term;
      $(this.input).trigger('input.header');
      $(this.input).trigger('input.algolia-search');
    },
    onFocus(e){
      if( this.input.value ){
        this.$emit('focus');
      }
    },
    onInput(e){
      this.query = this.input.value;
      const query = this.query.toLowerCase();
      this.$emit('input', query);
      if( !this.query ){
        if( !this.empty ) this.empty = true;
        [this.queries.allSites, this.queries.suggestions].forEach( q => q.hits = [] );
        return;
      }
      else {
        if( this.empty ) this.empty = false;
      }
      clearTimeout( this.inputTimeout );
      this.inputTimeout = setTimeout( () => this.search(), 200 );
    },

    clearCache(){
      for( let key in this.queries ) this.queries[key].$q.clearCache()
    },

    search(){
      const query = this.query;
      if( window && window.dataLayer ){
        window.dataLayer.push({
          event         : 'gaEvent',
          eventCategory : 'Search',
          eventAction   : 'Results',
          eventLabel    : this.query
        });
      }
      
      // lets get the filters
      let filters = this.activeFilters.map(f => {
        if( f.filter_type == 'attribute'){
          return f.condition.attribute_name+':'+f.condition.attribute_value
        }
        else {
          // we need to figure this out
          return null
        }
      }).filter(v => !!v);

      let filterString = filters.join(' OR ');
      
      if( this.featuredOnly ){
        let featuredQuery = 'is_sticky:1 OR has_search_keywords:true';
        if( filterString ){
          filterString = `(${filterString}) AND (${featuredQuery})`;
        }
        else {
          filterString = featuredQuery;
        }
      }

      // and date filters
      if( this.filterByDate ){
        let start = '';
        let end = new Date();
        switch(this.filterByDate){
          case '-1y':
            start = this.startOfYear();
            break;
          case '-1m':
            start = this.startOfMonth();
            break;
          case '-1q':
            start = this.startOfQuarter();
            break;
          case 'range':
            start = this.dateRange[0];
            end = this.dateRange[1];
            break;
        }
        if( start && end && start < end ){
          let dateRange = 'post_date:'+this.unixTimestamp(start)+' TO '+this.unixTimestamp(end)
          if( filterString ){
            filterString = `(${filterString}) AND (${dateRange})`;
          }
          else {
            filterString = dateRange;
          }
        }
      }

      const searchParameters = {};
      if( filterString ){
        searchParameters.params = {filters: filterString};
      }

      this.activeQuery.$q.search(query, searchParameters);
      this.queries.suggestions.$q.search(query);

      $(this.$el).closest('.header-search-results')[0].scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    toggleFilter(filter){
      if( filter ){
        filter.active = !filter.active;
      }
      this.availableFilters.forEach( f => {
        if( f!==filter ){
          f.active = false;
        }
      });
      this.search();
    }
  }

}
</script>

<style lang="scss" scoped>

@import '../../scss/front/variables';
@import '../../scss/common/mixins';
@import '../../scss/front/bootstrap-overrides';

@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
@import "~bootstrap/scss/_mixins";

.asa-sortby {
  gap: 10px;
  align-items: center;
}
.asa-sortby__options {
  display: flex;
  padding: 0;
  border: 1px solid #666;
  border-radius: 0.75rem;
  overflow: hidden;

}
.asa-sortby__option {
  list-style: none;
  padding: 0;
  margin: 0;
  &:not(:first-child){
    border-left: 1px solid #666;
  }
}
.asa-sortby__link {
  display: block;
  padding: 0.1em 0.75em;
  &.active {
    color: #fff;
    font-weight: 700;
    background: #000;
  }
}
.date-choices {
  gap: 0.75rem;

  button {
		
		border-radius: 0.75rem;
		margin: 0;
		flex: 1 1 auto;
		padding: 0.25rem 1rem;
		list-style: none;
		display: flex;
		gap: 0.5em;
		align-items: center;
		transition: 0.2s all;
		border-width: 0;
		border-style: none;
    justify-content: space-between;
    > span:last-child {
      flex: 0 1 auto;
    }
		&:hover {
			
		}
    &.btn-outline-primary:not(:disabled):not(.disabled).active {
      background-color: #fff;
      color: $color-midnight-blue;
      
    }
	}

  &::v-deep {
    .mx-datepicker{
      color: #fff;
      input.mx-input {
        background: rgba(#fff, 0.1);
        border-radius: 0.75rem;
        margin: 0;
        flex: 1 1 auto;
        padding: 0.25rem 1rem;
        list-style: none;
        display: flex;
        gap: 0.5em;
        align-items: center;
        transition: 0.2s all;
        border-width: 0;
        border-style: none;
        
        &:hover {
          background-color: rgba(#fff, 0.2);
        }
        &:not(:placeholder-shown) {
          background: #fff;
          color: $color-midnight-blue;
          + i {
            color: $color-midnight-blue;
          }
        }
        &::placeholder {
          color: #fff;
        }
      }
      i[class^="mx-"] {
        right: 16px;
        color: inherit;
        path {
          fill: currentColor !important;
        }
      }
    }
  }
}
</style>